import React, { memo } from 'react'
import { TableCell } from 'transfix-ui/components/Table'
import { Typography } from 'transfix-ui/core'
import { LaneAlert } from 'apps/marketplace/apiTypes/carrierLaneAlerts'
import { formatPickupAvailability } from './utils'

interface ISavedLaneTablePickupAvailabilityCellProps
  extends Pick<LaneAlert, 'id' | 'pickupIsoDaysOfWeek' | 'pickupStartDate' | 'trailerType'> {}

export const SavedLanesTablePickupAvailabilityCell = memo(
  ({
    id,
    pickupIsoDaysOfWeek,
    pickupStartDate,
    trailerType,
  }: ISavedLaneTablePickupAvailabilityCellProps) => {
    const pickupAvailabilityText = formatPickupAvailability({
      days: pickupStartDate || pickupIsoDaysOfWeek,
      equipmentName: trailerType,
    })
    return (
      <TableCell data-test={`saved-lane-${id}-pickup-availability`}>
        <Typography variant='body2'>{pickupAvailabilityText}</Typography>
      </TableCell>
    )
  }
)
